import { canonicalizeLocaleTag } from '../localeExperience';
import { EN_US_MESSAGES, type MessageKey } from './enUS';
import { PL_PL_MESSAGES } from './plPL';

export type { MessageKey } from './enUS';
export { EN_US_MESSAGES } from './enUS';
export { PL_PL_MESSAGES } from './plPL';

export type LocalizedMessageCatalog<Key extends string = MessageKey> = Readonly<
  Partial<Record<Key, string>>
>;

export const MESSAGE_CATALOGS: Readonly<Record<string, LocalizedMessageCatalog>> = Object.freeze({
  'en-US': EN_US_MESSAGES,
  'pl-PL': PL_PL_MESSAGES,
});

/** Resolve an exact or same-language catalog without consulting browser language. */
export function resolveMessageCatalogLocale(
  locale: string | null | undefined,
  catalogs: Readonly<Record<string, LocalizedMessageCatalog>> = MESSAGE_CATALOGS,
): string | null {
  const canonical = canonicalizeLocaleTag(locale);
  if (!canonical) return null;

  const entries = Object.keys(catalogs).map((key) => ({
    key,
    canonical: canonicalizeLocaleTag(key),
  }));

  const exact = entries.find((entry) => entry.canonical?.toLowerCase() === canonical.toLowerCase());
  if (exact) return exact.key;

  const language = canonical.split('-')[0]?.toLowerCase();
  return (
    entries.find((entry) => entry.canonical?.split('-')[0]?.toLowerCase() === language)?.key ?? null
  );
}
